import cls from "classnames"
import { chunk, clamp } from "lodash-es"
import { useCallback, useMemo, useState } from "react"

import { Modal } from "@/components/Modal"
import StrokeText from "@/components/StrokeText"
import { i18n } from "@/i18n"
import { RECALL_REWARD_MAP } from "../../const/reward"

import styles from "./index.module.scss"

interface Props {
    open: boolean
    onCancel: () => void
}

const PAGE_SIZE = 4
const PAGE_LIST = chunk(Object.values(RECALL_REWARD_MAP), PAGE_SIZE)
const TOTAL_PAGES = PAGE_LIST.length

const PoolModal: React.FC<Props> = (props) => {
    const { open, onCancel } = props

    const [page, setPage] = useState(0)

    const list = useMemo(() => PAGE_LIST[page], [page])

    const handlePage = useCallback(
        (page: number) => () => {
            setPage((val) => clamp(val + page, 0, TOTAL_PAGES - 1))
        },
        [],
    )

    const isWindows = useMemo(() => {
        return navigator.userAgent.includes("Windows")
    }, [])

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            contentClassName={styles.pool}
            cancelText={i18n.getRecall("common.prev")}
            cancelButtonProps={{
                onClick: handlePage(-1),
                disabled: page === 0,
            }}
            okText={i18n.getRecall("common.next")}
            okButtonProps={{
                onClick: handlePage(1),
                disabled: page === TOTAL_PAGES - 1,
            }}
        >
            <div className={styles.title}>
                <StrokeText
                    text={i18n.getRecall("menu.pool")}
                    fontFamily="Georgia-Bold"
                    fontSize={50}
                    fillColor="#ffffff"
                    borderWidth={3}
                    borderColor="#614518"
                    offsetY={0}
                    padding={3}
                    baselineAligned
                />
            </div>
            <div className={styles.list}>
                {list.map((reward) => (
                    <div key={reward.key} className={styles.reward}>
                        <div className={styles.icon}>
                            <div
                                style={{
                                    backgroundImage: `url(${reward.src})`,
                                }}
                            />
                        </div>
                        <div className={styles.info}>
                            {reward.title.split(" ").map((word, index) => (
                                <StrokeText
                                    key={index}
                                    text={word}
                                    fontFamily="Georgia-Bold"
                                    fontSize={22}
                                    fillColor="#8f7254"
                                    borderWidth={3}
                                    borderColor="#fffbf7"
                                    offsetY={0}
                                    padding={3}
                                    baselineAligned
                                    className={styles.text}
                                />
                            ))}
                            <div className={styles.divider} />
                            <div className={styles.amount}>
                                <div className={styles.label}>
                                    {i18n.getRecall("reward.amount")}
                                </div>
                                <div
                                    className={cls(
                                        styles.value,
                                        isWindows && styles.windows,
                                    )}
                                >
                                    <span>
                                        {String(reward.amount).padStart(2, "0")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    )
}

export default PoolModal
